const controller = '/statistics'
export default axios => ({
  getHomePageStats() {
    return axios.get(`${controller}/`)
  },
  
})
